import { createPerformanceSpans } from '../util/createPerformanceSpans.js';

function handleHistory(handlerData) {
  var from = handlerData.from,
      to = handlerData.to;
  var now = new Date().getTime() / 1000;
  return {
    type: 'navigation.push',
    start: now,
    end: now,
    name: to,
    data: {
      previous: from
    }
  };
}
/**
 * Returns a listener to be added to `addInstrumentationHandler('history', listener)`.
 */


function handleHistorySpanListener(replay) {
  return function (handlerData) {
    if (!replay.isEnabled()) {
      return;
    }

    var result = handleHistory(handlerData);

    if (result === null) {
      return;
    } // Need to collect visited URLs


    replay.getContext().urls.push(result.name);
    replay.triggerUserActivity();
    replay.addUpdate(function () {
      createPerformanceSpans(replay, [result]); // Returning false to flush

      return false;
    });
  };
}

export { handleHistorySpanListener };